import React from "react";
import { Card } from "@/components/ui/card";
import { tid } from "@/lib/testids";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <div data-testid={tid.termsPage} className="mx-auto max-w-4xl px-4 py-10">
      <Seo title="Terms of Service" description="AskIncog Terms of Service." />
      <Card className="border-slate-200/70 bg-white p-8">
        <h1 className="text-3xl font-bold text-slate-900">Terms of Service</h1>
        <p className="mt-3 text-sm leading-7 text-slate-600">
          AskIncog is an anonymous Q&A platform. By using the service, you agree to be respectful, avoid
          harassment, and not post illegal or harmful content. AI responses are informational and may be
          inaccurate.
        </p>
        <h2 className="mt-6 text-lg font-semibold text-slate-900">Guidelines</h2>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm leading-7 text-slate-600">
          <li>Be respectful and constructive</li>
          <li>No spam, self-promotion, or off-topic content</li>
          <li>No hate speech, harassment, or personal attacks</li>
          <li>No attempts to identify anonymous askers</li>
          <li>No medical/legal/financial advice presented as fact</li>
        </ol>
      </Card>
    </div>
  );
}
